import React from 'react'
import { baseUrl } from '@fs/zion-config'
import StructuredData from './StructuredData'

export const getVirtualLocationData = ({ url = `${baseUrl}/rootstech/` } = {}) => {
  return {
    '@type': 'VirtualLocation',
    url,
  }
}

export default function VirtualLocationStructuredData({ data }) {
  if (!data || Object.keys(data).length === 0) return null
  const structuredData = getVirtualLocationData(data)

  return <StructuredData data={structuredData} dataTestId="virtual-location-structured-data" />
}
